const ROUTE_CONSTANTS = {
  ADD_EDIT_ADVERTISEMENT: "/add-edit-advertise",
  ADVERTISEMENT_MANAGEMENT: "/advertise-mgmt",
  ADD_EDIT_EVENT: "/add-edit-event",
  APPROVE_MEMBER_DETAILS: "/member-approve/:id",
  EVENT_DETAILS: "/event-details/:id",
  EVENT_MANAGEMENT: "/event-mgmt",
  ADD_EDIT_MEMBER: "/add-edit-member",
  ADD_EDIT_ROLE: "/add-edit-role",
  ADD_EDIT_OPERATION_USER: "/add-edit-operation-user",
  DASHBOARD: "/dashboard",
  HOME: "/",
  LOGIN: "/login",
  MEMBER_MANAGEMENT: "/member-mgmt",
  MEMBER_DETAILS: "/member-details/:id",
  NO_ROLE_PAGE: "/no-dashboard",
  NOT_FOUND: "*",
  OPERATION_USER_MANAGEMENT: "/operation-user-mgmt",
  ROLE_MANAGEMENT: "/role-mgmt",
};

export default ROUTE_CONSTANTS;
